<!-- #region Note -->
<div class="_sidebar_" [class.active]="isNoteOpen" *ngIf="!isNoteOpen">
  <!-- Header -->
  <div class="notes-header">
    <div class="notes-header__title">
      <i class="pi pi-book"></i>
      <span>Notes</span>
    </div>
    <div class="notes-header__actions">
      <button type="button" class="icon-btn" pTooltip="Take a note" tooltipPosition="bottom" (click)="isNote = true; clearNotes()">
        <i class="pi pi-plus"></i>
      </button>
      <button
        type="button"
        class="icon-btn"
        *ngIf="getProjectNotes().length > 0"
        pTooltip="Copy project notes"
        tooltipPosition="bottom"
        (click)="copyProjectNotes()">
        <i class="pi pi-copy"></i>
      </button>
      <button
        type="button"
        class="icon-btn"
        *ngIf="notesList?.length > 0"
        [class.active]="isSelectMode"
        [pTooltip]="isSelectMode ? 'Cancel selection' : 'Select notes to copy'"
        tooltipPosition="bottom"
        (click)="toggleSelectMode()">
        <i class="pi" [ngClass]="isSelectMode ? 'pi-times-circle' : 'pi-check-square'"></i>
      </button>
      <button
        type="button"
        class="icon-btn"
        *ngIf="isSelectMode"
        [disabled]="selectedNoteIds.size === 0"
        pTooltip="Copy selected notes"
        tooltipPosition="bottom"
        (click)="copySelectedNotes()">
        <i class="pi pi-copy"></i>
        <span class="sel-count" *ngIf="selectedNoteIds.size > 0">{{ selectedNoteIds.size }}</span>
      </button>
      <button
        type="button"
        class="icon-btn"
        *ngIf="notesList?.length > 0"
        pTooltip="Copy notes to email"
        tooltipPosition="bottom"
        (click)="emailNotes()">
        <i class="pi pi-envelope"></i>
      </button>
      <button type="button" class="icon-btn" pTooltip="Open full notes page" tooltipPosition="bottom" (click)="isCloseNotes()">
        <i class="pi pi-external-link"></i>
      </button>
      <button type="button" class="icon-btn" pTooltip="Close" tooltipPosition="bottom" (click)="openNote()">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <!-- Search -->
  <div class="notes-search">
    <i class="pi pi-search"></i>
    <input type="text" placeholder="Search Notes" [(ngModel)]="notesSearch" (ngModelChange)="onNotesSearchChange()" />
    <i class="pi pi-times-circle clear" *ngIf="notesSearch" pTooltip="Clear" (click)="clearNotesSearch()"></i>
  </div>

  <!-- Type filter tabs -->
  <div class="notes-filters">
    <button type="button" class="filter-tab" [class.active]="activeTypeFilter === 'all'" (click)="setTypeFilter('all')">All</button>
    <button
      type="button"
      class="filter-tab"
      *ngFor="let t of getNoteTypeFilters()"
      [class.active]="activeTypeFilter === t"
      (click)="setTypeFilter(t)">
      {{ typeLabel(t) }}
    </button>
    <button type="button" class="filter-tab" [class.active]="activeTypeFilter === 'share'" (click)="setTypeFilter('share')">Shared</button>
  </div>

  <!-- Add note editor -->
  <div class="box_ note-editor mb-3" *ngIf="isNote">
    <button type="button" class="icon-btn close" pTooltip="Discard" tooltipPosition="left" (click)="clearNotes(); isNote = false">
      <i class="pi pi-times"></i>
    </button>

    <div class="assoc-search" (clickOutside)="_onClickOut($event)">
      <input
        type="text"
        class="note-title-input"
        placeholder="Add note name or search association"
        [(ngModel)]="note.title"
        (keyup)="onSearch()"
        (keydown)="onSearchKeydown($event)"
        [ngClass]="{ invalidField: submitted && !note.title }" />
      <div class="list_" *ngIf="searchBar?.length > 0; else NoSearchBar">
        <ul>
          <ng-container *ngFor="let item of searchBar">
            <ng-container *ngIf="item?.type !== 'other'">
              <p class="my-2 text-capitalize search-heading d-flex align-items-center">
                {{ item?.type == 'units' ? 'lots' : item?.type }}
              </p>
              <div
                class="mb-1 d-flex align-items-center add-hover cursor-pointer"
                *ngFor="let ele of item?.data"
                [class.highlighted]="isHighlighted(ele)"
                (click)="addItem(ele)">
                <img [src]="ele.icon" alt="" [ngStyle]="{ width: ele.wdth, 'margin-left': ele.margin }" />
                <p class="ml-2">{{ ele.title }}</p>
              </div>
              <p *ngIf="!item?.data?.length" class="my-1 ml-2 search-empty">No results</p>
            </ng-container>
          </ng-container>
        </ul>
      </div>
      <ng-template #NoSearchBar>
        <div class="list_" *ngIf="isLoad">
          <ul>
            <p class="my-2 ml-2 d-flex align-items-center">{{ isLoad }}</p>
          </ul>
        </div>
      </ng-template>
    </div>

    <div #customEditorAddNote class="editor mt-2" contenteditable></div>

    <div class="editControls">
      <button class="note-btn" pTooltip="Bold" tooltipPosition="top" (click)="setAddStyle('bold')">B</button>
      <button class="note-btn" pTooltip="Italic" tooltipPosition="top" (click)="setAddStyle('italic')"><em>I</em></button>
      <button class="note-btn" pTooltip="Underline" tooltipPosition="top" (click)="setAddStyle('underline')"><u>U</u></button>
      <button class="note-btn" pTooltip="Align left" tooltipPosition="top" (click)="setAddStyle('justifyLeft')">
        <i class="pi pi-align-left"></i>
      </button>
      <button class="note-btn" pTooltip="Align center" tooltipPosition="top" (click)="setAddStyle('justifyCenter')">
        <i class="pi pi-align-center"></i>
      </button>
      <button class="note-btn" pTooltip="Align right" tooltipPosition="top" (click)="setAddStyle('justifyRight')">
        <i class="pi pi-align-right"></i>
      </button>
      <button class="note-btn" pTooltip="Numbered list" tooltipPosition="top" (click)="setAddStyle('insertOrderedList')">
        <i class="pi pi-sort-numeric-down"></i>
      </button>
      <button class="note-btn" pTooltip="Bulleted list" tooltipPosition="top" (click)="setAddStyle('insertUnorderedList')">
        <i class="pi pi-list"></i>
      </button>
    </div>

    <div class="note-editor__footer">
      <a
        *ngIf="!listening"
        href="javascript:void(0)"
        class="voice-btn"
        (click)="startService(true)"
        pTooltip="Record a voice note"
        tooltipPosition="top"
        [showDelay]="300">
        <img [src]="images?.voice_icon" />
      </a>
      <a
        *ngIf="listening"
        href="javascript:void(0)"
        class="voice-btn recording"
        (click)="stopService()"
        pTooltip="Stop recording"
        tooltipPosition="top"
        [showDelay]="300">
        <i class="fa fa-stop-circle"></i>
      </a>

      <div class="note-editor__actions">
        <button class="_cancel-btn" (click)="clearNotes(); isNote = false">Close</button>
        <button class="_outline-btn" (click)="saveNotes()">Save</button>
      </div>
    </div>
  </div>

  <!-- Select-all bar (select mode) -->
  <div class="notes-select-bar" *ngIf="isSelectMode && notesList?.length > 0">
    <label class="select-all">
      <input type="checkbox" [checked]="areAllSelected()" (change)="toggleSelectAll()" />
      <span>Select all</span>
    </label>
    <span class="sel-summary">{{ selectedNoteIds.size }} selected</span>
  </div>

  <!-- Notes list -->
  <ng-container *ngIf="notesList?.length > 0; else emptyNotes">
    <div class="position-relative">
      <div class="s-custom-entity-records scroll_header_page" (scroll)="onScrollA($event)" #scrollableElement>
        <button type="button" class="scroll-top" (click)="scrollToTopA()" *ngIf="scrollTop > 50" pTooltip="Back to top" tooltipPosition="left">
          <i class="pi pi-arrow-up"></i>
        </button>

        <ng-container *ngFor="let item of getDisplayedNotes(); let idx = index">
          <div
            class="note-card"
            [class.pinned]="item.isPin"
            [class.select-mode]="isSelectMode"
            [class.selected]="isSelectMode && isNoteSelected(item)">
            <div class="note-card__top">
              <label class="note-select" *ngIf="isSelectMode">
                <input type="checkbox" [checked]="isNoteSelected(item)" (change)="toggleNoteSelection(item)" />
              </label>

              <h4 class="note-card__title" *ngIf="item.title">{{ item.title }}</h4>

              <div class="note-card__actions">
                <button
                  type="button"
                  class="icon-btn"
                  [class.active]="item.isPin"
                  [pTooltip]="item.isPin ? 'Unpin note' : 'Pin note'"
                  tooltipPosition="top"
                  (click)="item.isPin ? pinNote(item, false) : pinNote(item, true)">
                  <img class="pin-icon" [src]="item.isPin ? images?.pin_fill_icon : images?.pin_icon" width="12px" height="12px" alt="pin" />
                </button>
                <button type="button" class="icon-btn" pTooltip="Share note" tooltipPosition="top" (click)="openShare(item)">
                  <i class="pi pi-share-alt"></i>
                </button>
                <button type="button" class="icon-btn" pTooltip="Mark as done" tooltipPosition="top" (click)="archiveNote(item)">
                  <i class="pi pi-check"></i>
                </button>
                <button type="button" class="icon-btn danger" pTooltip="Delete note" tooltipPosition="top" (click)="deleteNote(item)">
                  <i class="pi pi-trash"></i>
                </button>
                <button type="button" class="icon-btn" pTooltip="Edit note" tooltipPosition="top" (click)="isEditNotes(item)">
                  <i class="pi pi-pencil"></i>
                </button>
              </div>
            </div>

            <div class="note-desc showDES" [class.clamped]="!isExpanded(item) && isLongNote(item)" [innerHTML]="item.desc"></div>
            <button type="button" class="show-toggle" *ngIf="isLongNote(item)" (click)="toggleExpand(item)">
              {{ isExpanded(item) ? 'Show less' : 'Show more' }}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-template #emptyNotes>
    <div class="no-results">
      <i class="pi" [ngClass]="notesSearch || activeTypeFilter !== 'all' ? 'pi-search' : 'pi-book'"></i>
      <p>{{ notesSearch || activeTypeFilter !== 'all' ? 'No notes match your search or filter' : 'No notes yet. Take a note above.' }}</p>
    </div>
  </ng-template>
</div>

<p-dialog
  header="Edit Note"
  [(visible)]="isEdit"
  [style]="{ width: '480px' }"
  [breakpoints]="{ '768px': '92vw' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="notes-edit-dialog"
  maskStyleClass="notes-edit-mask"
  (onHide)="clearNotes()">
  <div class="mt-3 assoc-search">
    <input
      type="text"
      placeholder="Add note name or search association"
      [(ngModel)]="note.title"
      (keyup)="onSearch()"
      (keydown)="onSearchKeydown($event)"
      [ngClass]="{ invalidField: submitted && !note.title }" />
    <div class="list_" *ngIf="searchBar?.length > 0">
      <ul>
        <ng-container *ngFor="let item of searchBar">
          <ng-container *ngIf="item?.type !== 'other'">
            <p class="my-2 text-capitalize search-heading d-flex align-items-center">
              {{ item?.type == 'units' ? 'lots' : item.type }}
            </p>
            <div
              class="mb-1 d-flex align-items-center add-hover cursor-pointer"
              *ngFor="let ele of item?.data"
              [class.highlighted]="isHighlighted(ele)"
              (click)="addItem(ele)">
              <img [src]="ele.icon" alt="" [ngStyle]="{ width: ele.wdth, 'margin-left': ele.margin }" />
              <p class="ml-2">{{ ele.title }}</p>
            </div>
            <p *ngIf="!item?.data?.length" class="my-1 ml-2 search-empty">No results</p>
          </ng-container>
        </ng-container>
      </ul>
    </div>
  </div>
  <div #customEditorEditNote class="edit-editor mt-2" [(innerHTML)]="note.desc" contenteditable></div>
  <div class="editControls">
    <button class="note-btn" pTooltip="Bold" tooltipPosition="top" (click)="setEditStyle('bold')">B</button>
    <button class="note-btn" pTooltip="Italic" tooltipPosition="top" (click)="setEditStyle('italic')"><em>I</em></button>
    <button class="note-btn" pTooltip="Underline" tooltipPosition="top" (click)="setEditStyle('underline')"><u>U</u></button>
    <button class="note-btn" pTooltip="Align left" tooltipPosition="top" (click)="setEditStyle('justifyLeft')">
      <i class="pi pi-align-left"></i>
    </button>
    <button class="note-btn" pTooltip="Align center" tooltipPosition="top" (click)="setEditStyle('justifyCenter')">
      <i class="pi pi-align-center"></i>
    </button>
    <button class="note-btn" pTooltip="Align right" tooltipPosition="top" (click)="setEditStyle('justifyRight')">
      <i class="pi pi-align-right"></i>
    </button>
    <button class="note-btn" pTooltip="Numbered list" tooltipPosition="top" (click)="setEditStyle('insertOrderedList')">
      <i class="pi pi-sort-numeric-down"></i>
    </button>
    <button class="note-btn" pTooltip="Bulleted list" tooltipPosition="top" (click)="setEditStyle('insertUnorderedList')">
      <i class="pi pi-list"></i>
    </button>
  </div>
  <div class="fx mb-3">
    <div class="ml-2">
      <a
        *ngIf="!listening"
        href="javascript:void(0)"
        class="mr-2"
        (click)="startService(false)"
        style="font-size: 24px; color: #229276"
        pTooltip="Record a voice note"
        tooltipPosition="top"
        [showDelay]="300"
        ><img [src]="images?.voice_icon" style="width: 24px !important"
      /></a>
      <a
        *ngIf="listening"
        href="javascript:void(0)"
        class="mr-2"
        (click)="stopService()"
        style="font-size: 24px; color: #229276"
        pTooltip="Stop recording"
        tooltipPosition="top"
        [showDelay]="300"
        ><i class="fa fa-stop-circle f-18"></i
      ></a>
    </div>
  </div>
  <div class="fx text-right">
    <button class="_cancel-btn mr-2" (click)="clearNotes()">Close</button>
    <button class="_outline-btn" (click)="updateNote(note)">Update</button>
  </div>
</p-dialog>

<!-- Share note overlay -->
<p-dialog
  [(visible)]="isShare"
  [style]="{ width: '25vw' }"
  [breakpoints]="{ '768px': '92vw' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  styleClass="notes-share-dialog"
  maskStyleClass="notes-edit-mask"
  (onHide)="closeShare()">
  <ng-template pTemplate="header">
    <div class="share-head">
      <span class="share-head__title">Share Note</span>
      <button type="button" class="share-head__close" (click)="closeShare()" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>

  <p class="share-intro">Share this note with users or teams to collaborate.</p>

  <div class="share-field">
    <div class="share-field__head">
      <i class="pi pi-user"></i>
      <span>Users</span>
    </div>
    <p class="share-field__hint">Select one or more users</p>
    <re-multiSelect [options]="shareUsers" [(ngModel)]="selectedShareUsers" optionLabel="full_name" optionValue="_id" placeholder="Select users">
    </re-multiSelect>
  </div>

  <div class="share-field">
    <div class="share-field__head">
      <i class="pi pi-users"></i>
      <span>Teams</span>
    </div>
    <p class="share-field__hint">Select one or more teams</p>
    <re-multiSelect [options]="shareTeams" [(ngModel)]="selectedShareTeams" optionLabel="name" optionValue="_id" placeholder="Select teams">
    </re-multiSelect>
  </div>

  <div class="share-foot mt-5">
    <button type="button" class="_cancel-btn" (click)="closeShare()">Cancel</button>
    <button type="button" class="_primary-btn" (click)="submitShare()">Share Note</button>
  </div>
</p-dialog>
